<template lang="pug">
    #customer-historic
        r-table(
            loading-text='Cargando datos...'
            no-data-text='Sin datos encontrados.'
            no-search
            no-remove
            ref='table'
            v-bind='tableProps'
            @detail='submitShow'
        )
            template( slot='actions' slot-scope='props' )
                r-btn-action( 
                    color='dark'
                    tooltip='PDF'
                    @click='submitPdf(props)' 
                )
                    v-icon picture_as_pdf
        detail-dialog(
            :invoice-id='invoiceId'
            read-only
            ref='invoiceReceivableDialog'
        )
        nc-detail-dialog(
          :creditNoteId="creditNoteId"
          :creditNoteModel="CreditNoteMdl"
          read-only
          ref='creditNoteDialog'
        )
        nd-detail-dialog(
          :debitNoteId="debitNoteId"
          :debitNoteModel="debitNoteMdl"
          read-only
          ref="debitNoteDialog"
        )
</template>

<script>
//
import { RBtnAction, RTable } from '@/components/reusable_components/next'
//
import SlTaxDocumentMdl from '@/models/Sale/SlTaxDocument.js'
import TableHeaders from './headers/allHistoricDocument'
import DetailDialog from '@/components/dialogs/invoice/InvoiceDetailDialog'
import DetailCreditNoteDialog from '@/components/reusable_components/DocumentDetail/creditNote/CreditNoteDetail'
import CreditNoteModel from '@/models/Sale/SlSaleCreditNote'
import DetailDebitNoteDialog from '@/components/reusable_components/DocumentDetail/debitNote/DebitNoteDetail'
import DebitNoteModel from '@/models/Sale/SlSaleDebitNote'
//
export default {
    name: 'customer-all-historic-invoice',
    components: {
        RBtnAction,
        RTable,
        'detail-dialog' : DetailDialog,
        'nc-detail-dialog' :DetailCreditNoteDialog,
        'nd-detail-dialog' :DetailDebitNoteDialog,
    },
    data() {
        return {
            headerTable: TableHeaders,
            filters: [
                {
                    name: 'dte_number',
                    props: {
                        label: 'Folio',
                    },
                    flex: {
                        sm6: true,
                        lg5: true,
                    },
                    type: 'text-field',
                },
            ],
            customerId: null,
            invoiceId: null,
            creditNoteId:null,
            CreditNoteMdl: CreditNoteModel,
            debitNoteId:null,
            debitNoteMdl : DebitNoteModel,
        }
    },
    computed: {
        tableProps() {
            return {
                service: SlTaxDocumentMdl,
                paramFilter: {
                    sl_customer_id: this.customerId,
                },
                headers: this.headerTable,
                filters: this.filters,
            }
        },
    },
    methods: {
        /**
         */
        setCustomerId() {
            this.customerId = this.$route.params.id
        },

        /**
         * Shows the pdf.
         *
         * @param      {object}  model   The model
         */
        showPdf(model) {
            return model.toPdf()
        },

        /**
         * @description
         * Print sale invoice PDF
         *
         * @param      {object}  event   The event
         * @return     {object}  blob file
         */
        submitPdf(event) {
            switch (event.item.dte_type) {
                case 33:
                    event.item.fetchSaleInvoice().then(this.showPdf)
            }
        },

        /**
         *
         */
        submitShow(event) {
            console.log(event,'here in submitshow')
            
            switch (event.item.dte_type) {
                case 33: //factura
                  this.invoiceId = event.item.id
                  this.$refs.invoiceReceivableDialog.open = true
                  break
                case 61: //nota de crédito
                  this.creditNoteId = event.item.id
                  this.$refs.creditNoteDialog.open = true
                  break
                case 56: //nota de débito
                  this.debitNoteId = event.item.id
                  this.$refs.debitNoteDialog.open = true
                  break
            }
        },
    },
    beforeMount() {
        this.setCustomerId()
    },
}
</script>
